export const desktopToolbarHeight = 110 as const;
export const mobileToolbarHeight = 60 as const;
